<template>
    <div id="blog-page">
        <div v-if="error" class="container mtb-80">
            <app-back :title="error"></app-back>
        </div>
        <app-flex-header></app-flex-header>
        <div class="abs" style="top: 200px; left:50px;">
            <h1 class="title has-text-limegreen" style="padding: 20px; background: rgba(0,0,0,0.3)">Blog o nemških ovčarjih, o Tesi, Oli, Lučki in Figaru, našemu mucu</h1>
        </div>

         <div class="container is-fluid bottom-header">
            <app-mail-categories-sticky :items="postsCategories"></app-mail-categories-sticky>
        </div>
        <div class="container is-fluid">
            <section class="articles columns is-multiline">
                <div class="column mt-10 is-full-mobile is-half-tablet is-one-third-desktop shadowing" v-for="post in posts" :key="post.title">
                    <div class="card-content">
                        <div class="media">
                            <div class="media-content has-text-centered">
                                <!-- post title -->
                                <p class="title article-title">
                                     <router-link  :to="'/blog/' + post.category.slug + '/' + post.slug">
                                        {{ post.title | capitalize }}
                                    </router-link>
                                </p>
                                <!-- category -->
                                <router-link :to="'/blog/' + post.category.slug" exact class="article-cat">
                                    <span class="icon">
                                        <i class="fa fa-tag"></i>
                                    </span> {{ post.category.name }}
                                </router-link>
                                <!-- user, date -->
                                <div class="tags has-addons level-item">
                                    <span class="tag is-rounded is-success1">@{{post.user.first_name }} {{ post.user.last_name }} </span>
                                    <span class="tag is-rounded">
                                        {{ post.created }}
                                    </span>
                                    <!-- <span class="block small" v-if="!!post.updated">
                                       (Posodobljeno: {{ post.updated }})
                                   </span> -->
                               </div>
                           </div>
                       </div>
                       <!-- content -->
                       <div class="content article-body" v-html="post.content">
                       </div>
                    </div>
                    <div class="card-foot">
                       <hr />
                       <app-centered-button :link="'/blog/' + post.category.slug + '/' + post.slug" text="Beri naprej"></app-centered-button>
                    </div>
               </div>
           </section>
       </div>
   </div>
</template>

<script>
import { ApiHome } from '../../.env';
import { mapGetters } from 'vuex';
import StringsMixin from '../../mixins/StringsMixin';
import HeaderBar from '../../components/layout/HeaderBar.vue';
import BackButton from '../../components/layout/BackButton.vue';
import MoreButton from '../../components/layout/MoreButton.vue';
import Silentbox from '../../components/elements/silentbox/Silentbox.vue';
import FlexHeaderBar from '../../components/layout/FlexHeaderBar';

// import Pagination from '../../components/elements/pagination/Pagination.vue';
import MailCategoriesSticky from '../../components/layout/MailCategoriesSticky.vue';

export default {
    props: ['photo'],
    mixins: [StringsMixin],

    data() {
        return {
            endpoint: ApiHome+ 'posts',
            endpointSearch: ApiHome + 'searchPosts',
            query: '',
            errorClass: '',
        }
    },

    components: {
        'app-header': HeaderBar,
        'app-sb': Silentbox,
        'app-back': BackButton,
        'app-centered-button': MoreButton,
        'app-mail-categories-sticky': MailCategoriesSticky,
        'app-flex-header': FlexHeaderBar,
        // 'app-pagination': Pagination,
    },

    computed: {
        ...mapGetters([
            'posts',
            'postsCategories',
            'loading',
            'error',
            'title',
            // 'paginate',
            // 'pagination',
        ]),


        imagePath() {
            // console.log('image path: ', PhotoUrl);
            // return PhotoUrl + this.gallery.album_id + '/original/';
        },

    },

    methods: {

        fetchPosts() {
            let data = {
                endpoint: this.endpoint
            }
            this.$store.dispatch('fetchPosts', this.endpoint);
        },

        postDate(post) {
            if(post.updated === '') {
                return post.created;
            }
            return post.updated;
        },

    },

    created() {
        this.fetchPosts();
        // console.log('Blog - Component mounted.')
    }
}
</script>


<style lang="scss">

@import "../../style/app.scss";
@import "../../style/blog.scss";
.is-success1 {
    background: lightgray !important;
}
</style>


// WEBPACK FOOTER //
// src/views/blog/Blog.vue